import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router-dom';

function PrivateRoute({ user, path, component: Component }) {
  if (user?.account?.xbot?.support || (user?.unit?.admins ?? []).includes(user.email)) {
    return <Route exact path={path} render={(props) => <Component {...props} />} />;
  }
  return (
    <Route
      exact
      path={path}
      render={(props) => <Redirect to={{ pathname: '/', state: { from: props.location } }} />}
    />
  );
}

const mapStateToProps = ({ user }) => ({
  user,
});

export default withRouter(connect(mapStateToProps)(PrivateRoute));
